"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.Plan_967 = exports.Plan_966 = exports.Plan_965 = exports.Plan_964 = void 0;
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var Plan_964 = exports.Plan_964 = {
  planNumber: 964,
  kindOfCover: "Ext Accident",
  externalName: "Silver Cover",
  coolingOffPeriod: true,
  gapOnly: true,
  dental: false,
  routineCare: false,
  emergencyBoarding: true,
  emergencyBoardingFees: "$1,000",
  petSpecies: ["CANINE"],
  upmExcessOptions: [{
    "excess": 0,
    "levelOfCover": 80,
    "excessCode": "3917",
    "excessNo": 3917
  }, {
    "excess": 250,
    "levelOfCover": 80,
    "excessCode": "3918",
    "excessNo": 3918
  }, {
    "excess": 500,
    "levelOfCover": 80,
    "excessCode": "3919",
    "excessNo": 3919
  }],
  levelsOfCover: [80],
  staffOnly: false,
  staffLevelsOfCover: [],
  stepDownLevelsOfCover: [],
  stepDown: false,
  limits: {
    "ageLimits": {
      "minAgeDays": 55,
      "maxAgeDays": 5479,
      "displayValue": "Older than 8 weeks and younger than 15 years"
    },
    "annualLimit": {
      "amount": 20000,
      "formattedAmount": "$20,000",
      "displayValue": "$20,000"
    },
    "paralysisTick": "$2,000 sub-limit",
    "tickParalysis": "$2,000 sub-limit",
    "consultationLimit": "$500 sub-limit",
    "consultationsAndVet": "$500 sub-limit",
    "consultationsAndVisits": "$500 sub-limit",
    "consultation": true,
    "cruciateLigament": "$3,000 sub-limit per leg",
    "cruciateLigamentLimit": "$3,000 sub-limit",
    "cruciateLigamentLeftLeg": "$3,000 sub-limit",
    "cruciateLigamentRightLeg": "$3,000 sub-limit",
    "hipJointLeftHip": "$6,000 sub-limit per hip",
    "hipJointRightHip": "$6,000 sub-limit per hip",
    "emergencyBoardingFees": "$1,000",
    "emergencyBoardingLimit": "$1,000 sub-limit"
  },
  waitingPeriods: {
    "detailed": {
      "waitingPeriodMessages": ["No waiting period for specified accidental injuries.", "21 days for specified illness conditions."],
      "waitingPeriod": "No waiting period for specified accidental injuries.<br/>21 days for specified illness conditions.",
      "itemisedWaitingPeriods": {
        "specifiedAccidentalInjuries": {
          "waitTime": "No waiting period",
          "label": "specified accidental injuries"
        },
        "specifiedIllnessConditions": {
          "waitTime": "21 days",
          "label": "specified illness conditions"
        }
      }
    }
  },
  customCoverDetails: {
    "afterLifeCare": false,
    "alprazolam": false,
    "amitriptyline": false,
    "anaphylacticShock": false,
    "behaviouralAssessment": false,
    "behaviouralTherapy": false,
    "councilRegistration": false,
    "desexing": false,
    "developmentalHereditary": false,
    "developmentalHereditary2": false,
    "essentialEuthanasia": false,
    "extendedAccidentEvent": false,
    "fleaControlDrugs": false,
    "fleaTickControlDrugs": false,
    "fleaWormDrugs": false,
    "heartWormDrugs": false,
    "intestinalWormDrugs": false,
    "jointSupplements": false,
    "microchipping": false,
    "oralRinseDrugs": false,
    "prescriptionDiet": false,
    "routineTeethCleaning": false,
    "teethCleaningProducts": false,
    "trazodone": false,
    "vaccinationCat": false,
    "vaccinationDog": false,
    "coversIllness": true,
    "toxicityPoisoning": true,
    "trichobezoar": true,
    "ingestionOfForeignBodies": true,
    "ingestionToxicity": true,
    "hereditary": false
  },
  isBasePlan: true,
  addOns: []
};
var Plan_965 = exports.Plan_965 = _objectSpread(_objectSpread({}, Plan_964), {}, {
  planNumber: 965,
  externalName: "Silver Cover with Dental Illness Benefit",
  dental: true,
  upmExcessOptions: [{
    "excess": 0,
    "levelOfCover": 80,
    "excessCode": "3920",
    "excessNo": 3920
  }, {
    "excess": 250,
    "levelOfCover": 80,
    "excessCode": "3921",
    "excessNo": 3921
  }, {
    "excess": 500,
    "levelOfCover": 80,
    "excessCode": "3922",
    "excessNo": 3922
  }],
  limits: _objectSpread(_objectSpread({}, Plan_964.limits), {}, {
    dentalCareLimit: "$1,000",
    dentalLimitBreakDown: undefined,
    routineCareLimit: undefined,
    routineCareLimitBreakDown: undefined,
    alternativeCareLimit: undefined,
    alternativeCareLimitBreakdown: undefined
  }),
  waitingPeriods: _objectSpread(_objectSpread({}, Plan_964.waitingPeriods), {}, {
    detailed: _objectSpread(_objectSpread({}, Plan_964.waitingPeriods.detailed), {}, {
      waitingPeriodMessages: ["No waiting period for specified accidental injuries.", "21 days for general veterinary expenses.", "No waiting period for emergency boarding.", "6 months for dental illness treatments where selected."],
      waitingPeriod: "No waiting period for specified accidental injuries.<br/>21 days for general veterinary expenses.<br/>No waiting period for emergency boarding.<br/>6 months for dental illness treatments where selected.",
      itemisedWaitingPeriods: _objectSpread(_objectSpread({}, Plan_964.waitingPeriods.detailed.itemisedWaitingPeriods), {}, {
        generalVeterinaryExpenses: {
          "waitTime": "21 days",
          "label": "general veterinary expenses"
        },
        emergencyBoarding: {
          "waitTime": "No waiting period",
          "label": "emergency boarding"
        },
        dental: {
          "waitTime": "6 months",
          "label": "dental illness treatments where selected"
        }
      })
    })
  }),
  customCoverDetails: _objectSpread({}, Plan_964.customCoverDetails),
  isVariant: true,
  basePlanNo: 964,
  addOns: ["dental"],
  isBasePlan: false
});
var Plan_966 = exports.Plan_966 = _objectSpread(_objectSpread({}, Plan_964), {}, {
  planNumber: 966,
  externalName: "Silver Cover with Routine Care",
  routineCare: true,
  upmExcessOptions: [{
    "excess": 0,
    "levelOfCover": 80,
    "excessCode": "3923",
    "excessNo": 3923
  }, {
    "excess": 250,
    "levelOfCover": 80,
    "excessCode": "3924",
    "excessNo": 3924
  }, {
    "excess": 500,
    "levelOfCover": 80,
    "excessCode": "3925",
    "excessNo": 3925
  }],
  limits: _objectSpread(_objectSpread({}, Plan_964.limits), {}, {
    dentalCareLimit: undefined,
    dentalLimitBreakDown: undefined,
    routineCareLimit: "$150",
    routineCareLimitBreakDown: [{
      "description": "Routine Group",
      "code": "RGPINSCOM",
      "limit": 100
    }, {
      "description": "Routine Group",
      "code": "RGPINS_PLU",
      "limit": 50
    }],
    alternativeCareLimit: undefined,
    alternativeCareLimitBreakdown: undefined
  }),
  waitingPeriods: _objectSpread(_objectSpread({}, Plan_964.waitingPeriods), {}, {
    detailed: _objectSpread(_objectSpread({}, Plan_964.waitingPeriods.detailed), {}, {
      waitingPeriodMessages: ["No waiting period for specified accidental injuries.", "21 days for general veterinary expenses.", "No waiting period for emergency boarding.", "No waiting period for routine care where selected."],
      waitingPeriod: "No waiting period for specified accidental injuries.<br/>21 days for general veterinary expenses.<br/>No waiting period for emergency boarding.<br/>No waiting period for routine care where selected.",
      itemisedWaitingPeriods: _objectSpread(_objectSpread({}, Plan_964.waitingPeriods.detailed.itemisedWaitingPeriods), {}, {
        generalVeterinaryExpenses: {
          "waitTime": "21 days",
          "label": "general veterinary expenses"
        },
        emergencyBoarding: {
          "waitTime": "No waiting period",
          "label": "emergency boarding"
        },
        routineCare: {
          "waitTime": "No waiting period",
          "label": "routine care where selected"
        }
      })
    })
  }),
  customCoverDetails: _objectSpread({}, Plan_964.customCoverDetails),
  isVariant: true,
  basePlanNo: 964,
  addOns: ["routineCare"],
  isBasePlan: false
});
var Plan_967 = exports.Plan_967 = _objectSpread(_objectSpread({}, Plan_964), {}, {
  planNumber: 967,
  externalName: "Silver Cover with Routine Care and Dental Illness Benefit",
  dental: true,
  routineCare: true,
  upmExcessOptions: [{
    "excess": 0,
    "levelOfCover": 80,
    "excessCode": "3926",
    "excessNo": 3926
  }, {
    "excess": 250,
    "levelOfCover": 80,
    "excessCode": "3927",
    "excessNo": 3927
  }, {
    "excess": 500,
    "levelOfCover": 80,
    "excessCode": "3928",
    "excessNo": 3928
  }],
  limits: _objectSpread(_objectSpread({}, Plan_964.limits), {}, {
    dentalCareLimit: "$1,000",
    dentalLimitBreakDown: undefined,
    routineCareLimit: "$150",
    routineCareLimitBreakDown: [{
      "description": "Routine Group",
      "code": "RGPINSCOM",
      "limit": 100
    }, {
      "description": "Routine Group",
      "code": "RGPINS_PLU",
      "limit": 50
    }],
    alternativeCareLimit: undefined,
    alternativeCareLimitBreakdown: undefined
  }),
  waitingPeriods: _objectSpread(_objectSpread({}, Plan_964.waitingPeriods), {}, {
    detailed: _objectSpread(_objectSpread({}, Plan_964.waitingPeriods.detailed), {}, {
      waitingPeriodMessages: ["No waiting period for specified accidental injuries.", "21 days for general veterinary expenses.", "No waiting period for emergency boarding.", "6 months for dental illness treatments where selected.", "No waiting period for routine care where selected."],
      waitingPeriod: "No waiting period for specified accidental injuries.<br/>21 days for general veterinary expenses.<br/>No waiting period for emergency boarding.<br/>6 months for dental illness treatments where selected.<br/>No waiting period for routine care where selected.",
      itemisedWaitingPeriods: _objectSpread(_objectSpread({}, Plan_964.waitingPeriods.detailed.itemisedWaitingPeriods), {}, {
        generalVeterinaryExpenses: {
          "waitTime": "21 days",
          "label": "general veterinary expenses"
        },
        emergencyBoarding: {
          "waitTime": "No waiting period",
          "label": "emergency boarding"
        },
        dental: {
          "waitTime": "6 months",
          "label": "dental illness treatments where selected"
        },
        routineCare: {
          "waitTime": "No waiting period",
          "label": "routine care where selected"
        }
      })
    })
  }),
  customCoverDetails: _objectSpread({}, Plan_964.customCoverDetails),
  isVariant: true,
  basePlanNo: 964,
  addOns: ["dental", "routineCare"],
  isBasePlan: false
});
var _default = exports["default"] = {
  Plan_964: Plan_964,
  Plan_965: Plan_965,
  Plan_966: Plan_966,
  Plan_967: Plan_967
};